const useContentSectionContainerStyles = () => {
    return {
        contentContainer: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            borderRadius: 3,
            minHeight: 'calc(100dvh - 192px)',
            height: 'calc(100dvh - 192px)',
            maxHeight: 'calc(100dvh - 192px)',
            overflow: 'hidden',
            background: (theme) => theme.palette.background.paper
        }
    };
};
export default useContentSectionContainerStyles;
